import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchDataForBiddingConsolePage } from '@/redux/modules/biddingConsole';
import { fetchLiveCatalogRegistrationIfNeeded } from '@/redux/modules/catalogRegistration';
import { getCatalog } from '@/redux/modules/catalog';
import { getIdFromPath } from '@/utils/urls';
import { recordAnalyticsForBidConsolePageView } from '@/redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const { pathname } = location;
    const { dispatch, getState } = store;
    const catalogId = getIdFromPath(pathname);

    return Promise.all([dispatch(fetchDataForBiddingConsolePage(catalogId))]).then(() => {
        const state = getState();
        const { sellerId } = getCatalog(state, catalogId);
        return Promise.all([
            dispatch(recordAnalyticsForBidConsolePageView(catalogId)),
            dispatch(fetchLiveCatalogRegistrationIfNeeded(catalogId, sellerId)),
        ]);
    });
};
